import { render, staticRenderFns } from "./ylfwPackage_see.vue?vue&type=template&id=5d60b2d6&scoped=true&"
import script from "./ylfwPackage_see.vue?vue&type=script&lang=js&"
export * from "./ylfwPackage_see.vue?vue&type=script&lang=js&"
import style0 from "./ylfwPackage_see.vue?vue&type=style&index=0&id=5d60b2d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d60b2d6",
  null
  
)

export default component.exports